module.exports = __webpack_public_path__ + "static/media/carta_73.b17f424d.jpg";